import axios from "axios";
import env from "../config/env";

const http = axios.create({
    baseURL: env.apiUrl,
});

export default http;
